var React = require('react');

function Hamsa (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M288 352a32 32 0 1 1-32-32 32 32 0 0 1 32 32z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M509.34 307.25A32 32 0 0 0 480 288h-64V80a40 40 0 0 0-80 0v134a10 10 0 0 1-10 10h-20a10 10 0 0 1-10-10V40a40 40 0 0 0-80 0v174a10 10 0 0 1-10 10h-20a10 10 0 0 1-10-10V80a40 40 0 0 0-80 0v208H32a32 32 0 0 0-23.4 53.83l102.69 110C147 490.08 199.69 512 256 512s109-21.92 144.72-60.14l102.68-110a32 32 0 0 0 5.94-34.61zM256 416c-53 0-96-64-96-64s43-64 96-64 96 64 96 64-43 64-96 64z","className":"fa-primary","key":2})]);
}

Hamsa.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Hamsa;

Hamsa.default = Hamsa;
